import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { AdminService } from '../../../../../../../../../services/admin/admin.service';
import { TdLoadingService } from '@covalent/core';

@Component({
  selector: 'app-add-employee-dialog',
  templateUrl: './add-employee-dialog.component.html',
  styleUrls: ['./add-employee-dialog.component.scss']
})
export class AddEmployeeDialogComponent implements OnInit {
  dataForSelectEmployee: any = []
  selectedEmployees: any = [];
  constructor(
    public dialogRef: MatDialogRef<AddEmployeeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _adminService: AdminService,
    private _loadingService: TdLoadingService,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.loadData();
  }
  closeDialog() {
    this.dialogRef.close();
  }
  loadData() {
    this._loadingService.register()
    this._adminService.getMajorEmployees().subscribe((employees: any) => {
      this._loadingService.resolve();
      employees.forEach(employee => {
        const existingEmployeeIndex = this.data.tasks.findIndex((e) => {
          return e.employeeId == employee.id;
        });
        const roleObj = employee.roles.find(role => role.clientId = 41)
        if (this.data.changeMode == 'SUPERVISE' && roleObj.role === 'PT.SUPERVISE.READ' && existingEmployeeIndex == -1) {
          this.dataForSelectEmployee.push(employee);
        }
        if (this.data.changeMode == 'EXECUTE' && roleObj.role === 'PT.EXECUTE.READ' && existingEmployeeIndex == -1) {
          this.dataForSelectEmployee.push(employee);
        }
      });
    },
    (err) => {
      this._loadingService.resolve()
      this._snackBar.open('დაფიქსირდა შეცდომა',null,{
        duration:2000,
        panelClass:'red-snackbar',
        horizontalPosition:"right",
        verticalPosition:"top"
      })
    })
  }
  selectEmployee(employee, e) {
    const idx = this.selectedEmployees.findIndex((selectedEmployee) => {
      return selectedEmployee.id == employee.id;
    })
    if (idx > -1) {
      this.selectedEmployees.splice(idx, 1);
    }
    else {
      this.selectedEmployees = this.data.changeMode == 'SUPERVISE' ? [] : this.selectedEmployees;
      this.selectedEmployees.push(employee);
    }

  }
  checkedEmployees(id) {
    return this.selectedEmployees.findIndex((e) => {
      return e.id == id
    }) > -1;
  }
  addEmployee() {
    if (this.data.changeMode === 'SUPERVISE') {
      this.changeSupervisor();
    }
    if (this.data.changeMode === 'EXECUTE') {
      this.addExecutor();
    }

  }
  changeSupervisor() {
    this._loadingService.register()
    const data = {
      petitionId: this.data.petition.id,
      taskId: this.data.tasks[0].taskId,
      commentary: this.selectedEmployees[0].comment,
      employeeId: this.selectedEmployees[0].id
    }
    this._adminService.changeSupervisor(data).subscribe(res => {
      this._loadingService.resolve();
      this.dialogRef.close('შემსრულებელი შეცვლილია');
    },
    (err) => {
      this._loadingService.resolve()
      this._snackBar.open('დაფიქსირდა შეცდომა',null,{
        duration:2000,
        panelClass:'red-snackbar',
        horizontalPosition:"right",
        verticalPosition:"top"
      })
    })
  }
  addExecutor() {
    this._loadingService.register()
    const data = {
      petitionId: this.data.petition.id,
      executors: this.selectedEmployees.map(employee => {
        return {
          employeeId: employee.id,
          commentary: employee.comment
        }
      })
    }
    this._adminService.addTaskExecutor(data).subscribe(res => {
      this._loadingService.resolve();
      this.dialogRef.close('შემსრულებელი დამატებულია');
    },
    (err) => {
      this._loadingService.resolve()
      this._snackBar.open('დაფიქსირდა შეცდომა',null,{
        duration:2000,
        panelClass:'red-snackbar',
        horizontalPosition:"right",
        verticalPosition:"top"
      })
    })
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/shared/petition-details/dialogs/review-results-dialog/dialogs/add-employee-dialog/add-employee-dialog.component.ts